





































































































































import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import { EnrollmentOrderShortList as IEnrollmentOrderList } from "@/api/models/enrollment-order-short-list";
import { EnrollmentOrderShort as IEnrollmentOrder } from "@/api/models/enrollment-order-short";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { Course as ICourse } from "@/api/models/course";
import { Employee as IEmployee } from "@/api/models/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import {
  getCurrentUserId,
  getCurrentCompanyId,
  isRoot,
  currentUserIsCompanyOwner,
  getCurrentEmployee
} from "@/plugins/roles";
import enrollments, {
  EnrollmentOrdersListParam
} from "@/getinfo-api/enrollment-orders";
import EnrollmentOrderListItem from "@/components/enrollment/EnrollmentOrderListItem.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import { CoursesListClass } from "@/classes/list/CoursesListClass";
import CSingleSelect from "@/components/form/CSingleSelect.vue";

@Component({
  components: {
    CSingleSelect,
    CField,
    CPage,
    SelectEntity,
    EnrollmentOrderListItem,
    CustomButton,
    CustomDatepicker
  }
})
export default class EnrollmentOrderList extends Vue {
  @Ref("selectCourse") _selectCourse!: SelectEntity;
  enrollmentOrderList: Array<IEnrollmentOrder> = [];
  enrollmentOrderCount: number = 0;
  number!: string | undefined;
  signedAtMin!: Date | undefined;
  signedAtMax!: Date | undefined;
  formedAtMin?: Date | undefined;
  formedAtMax?: Date | undefined;
  createdAtMin?: Date | undefined;
  createdAtMax?: Date | undefined;
  updatedAtMin?: Date | undefined;
  updatedAtMax?: Date | undefined;
  courseId!: string | undefined;
  ownerId!: string | undefined;
  employees!: Array<IEmployee>;
  limit: number = 30;
  offset: number = 0;
  showSpinner: boolean = false;
  local: boolean = true;
  createdDataValue?: string;
  createdDataValueDouble?: string;
  gettingResult: boolean = false;
  signedAt: boolean | undefined;
  list: boolean = true;
  sortedBy: any = "formedAt";
  order?: "ASC" | "DESC" = "DESC";
  reset: boolean = true;
  courseClass: CoursesListClass = new CoursesListClass({});

  data() {
    return {
      signedAt: undefined,
      number: undefined,
      createdAtMin: undefined,
      createdAtMax: undefined,
      signedAtMin: undefined,
      signedAtMax: undefined,
      updatedAtMin: undefined,
      formedAtMax: undefined,
      formedAtMin: undefined,
      updatedAtMax: undefined,
      courseId: undefined,
      ownerId: undefined,
      employees: undefined
    };
  }

  sortDocuments(sortType: any) {
    if (this.sortedBy === sortType) {
      this.order = this.order === "DESC" ? "ASC" : "DESC";
    } else {
      this.order = "DESC";
    }
    this.sortedBy = sortType;
    this.enrollmentOrderList = [];
    this.searchEnrollment(0);
  }

  deleteEnrollment() {
    this.applyFilter();
  }

  get iconClass() {
    return this.order === "DESC"
      ? "fas fa-long-arrow-alt-down"
      : "fas fa-long-arrow-alt-up";
  }

  get changeText() {
    if (this.local) {
      return (this.createdDataValue = `${this.$tc(
        this.$translate.CreationDate
      )} ↓`);
    } else {
      return (this.createdDataValueDouble = `${this.$tc(
        this.$translate.CreationDate
      )} ↑`);
    }
  }

  get screenWidth() {
    return window.innerWidth;
  }

  applyFilter() {
    this.enrollmentOrderList = [];
    this.offset = 0;
    this.searchEnrollment();
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  showMore() {
    this.offset += this.limit;
    this.searchEnrollment(this.offset);
  }

  searchEnrollment(offset: number = 0) {
    this.showSpinner = true;
    this.gettingResult = true;
    let params: EnrollmentOrdersListParam = {
      courseIds: this.courseId ? [this.courseId] : undefined,
      number: this.number,
      companyId: this.selectedCompany,
      ownerId: this.ownerId,
      signedAtMin: this.signedAtMin,
      signedAtMax: this.signedAtMax,
      createdAtMin: this.createdAtMin,
      createdAtMax: this.createdAtMax,
      updatedAtMin: this.updatedAtMin,
      updatedAtMax: this.updatedAtMax,
      formedAtMax: this.formedAtMax,
      formedAtMin: this.formedAtMin,
      offset: offset,
      limit: this.limit,
      signedAt: this.signedAt,
      sort: this.sortedBy,
      order: this.order
    };

    enrollments(params)
      .then((res: { data: IEnrollmentOrderList }) => {
        this.enrollmentOrderCount = res.data.count;
        res.data.items?.forEach(el => {
          this.enrollmentOrderList.push(el);
          this.gettingResult = false;
        });
      })
      .finally(() => {
        this.gettingResult = false;
        this.showSpinner = false;
      });
  }

  clearForm() {
    this.courseId = undefined;
    this.ownerId = undefined;
    this.number = undefined;
    this.signedAtMin = undefined;
    this.signedAtMax = undefined;
    this.signedAt = undefined;
    this.updatedAtMin = undefined;
    this.updatedAtMax = undefined;
    this.createdAtMin = undefined;
    this.createdAtMax = undefined;
    this.formedAtMax = undefined;
    this.formedAtMin = undefined;
    this.enrollmentOrderList = [];
    this.reset = false;
    this.$nextTick(() => (this.reset = true));
    this.searchEnrollment();
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get contentManager() {
    return this.$store.getters.roles?.includes("content_manager");
  }

  @Watch("selectedCompany")
  updateEmployees() {
    this.clearForm();
    this.getContentManagers();
    this.courseClass = new CoursesListClass({});
  }

  getContentManagers() {
    let params: EmployeeListParams = {
      id: this.selectedCompany,
      roles: ["content_manager"],
      userIds: this.root || this.companyOwner ? undefined : [this.userId],
      limit: 500
    };

    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.employees = res.data.employees;
    });
  }

  selectCourse(course: ICourse) {
    if (course.id) {
      this.courseId = course.id;
    } else {
      this.courseId = undefined;
    }
  }

  created() {
    this.getContentManagers();
    this.searchEnrollment();
  }
}
